import {Col, Row} from "reactstrap";

import Copyright from "./components/copyright";
import LinkSections from "./components/linkSections";


import "./style.scss";
import {BsTruck} from "react-icons/bs";
import pay from "@assets/icons/privecyPay.webp"
import product from "@assets/icons/product.webp"
import send from "@assets/icons/fastSend.webp"
import support from "@assets/icons/support.webp"
const Footer = () => {
    const footerInformation = [
        {
            title:"پرداخت امن:",
            des:"پرداخت آسان و امن در فدرا",
            image:pay
        },
        {
            title:"خرید محصولات سفارشی:",
            des:"با اطمینان کامل پرداخت و خرید انجام دهید",
            image:product
        },
        {
            title:"ارسال سریع:",
            des:"ارسال در سریع ترین زمان ممکن",
            image:send
        },
        {
            title:"پشتیبانی:",
            des:"با پشتیبانی 24 ساعته همراهتان هستیم",
            image:support
        },


    ]
    return (
        <footer className="footer-container">
            {/*<Row className="footer-container-information container-costumer">
                {
                    footerInformation?.map((item)=>{
                        return (
                            <Col xs={12} sm={6} md={3}>
                                <div
                                    className=" rounded footer-container-information-box d-flex justify-content-center flex-column align-items-center ">
                                    <img src={item.image} width={30} className="mb-1"/>
                                    <div className=" mb-1 footer-container-information-box-title ">{item.title}</div>
                                    <div className="text-justify footer-container-information-box-des">{item.des}</div>
                                </div>
                            </Col>
                        )
                    })
                }
            </Row>*/}
            <div className=''>
                <div className="container-costumer">
                    <Row className="w-100 ">
                        <Col sm={12} md={12}>
                            <LinkSections/>
                        </Col>
                    </Row>
                </div>

                <Copyright/>
            </div>
        </footer>
    );
};

export default Footer;
